export const comments = [
  {
    id: 'comment-001',
    author: '吃瓜群众一号',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20cheerful%20young%20Chinese%20person%20eating%20watermelon%2C%20fun%20casual%20style%2C%20warm%20natural%20lighting%2C%20clean%20simple%20background%2C%20social%20media%20profile%20photo%20style&width=80&height=80&seq=comment-avatar-001&orientation=squarish',
    content: '我的天！这个瓜也太大了，房子彻底塌了，从昨天刷到现在根本停不下来！吃瓜爆料真的是全网最快的爆料平台。',
    date: '2026-07-02',
    likes: 342,
  },
  {
    id: 'comment-002',
    author: '八卦达人',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20stylish%20young%20Chinese%20woman%20with%20curious%20intrigued%20expression%2C%20trendy%20outfit%2C%20warm%20natural%20lighting%2C%20clean%20simple%20background%2C%20social%20media%20profile%20photo%20style&width=80&height=80&seq=comment-avatar-002&orientation=squarish',
    content: '早就觉得不对劲了，每次出席活动都一副心不在焉的样子，原来早就结婚生子了。粉丝们真的太可怜了。',
    date: '2026-07-02',
    likes: 567,
  },
  {
    id: 'comment-003',
    author: '理性看客',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20thoughtful%20middle%20aged%20Chinese%20man%20with%20calm%20analytical%20expression%2C%20wearing%20glasses%2C%20warm%20natural%20lighting%2C%20clean%20simple%20background%2C%20social%20media%20profile%20photo%20style&width=80&height=80&seq=comment-avatar-003&orientation=squarish',
    content: '我觉得明星也有隐私权吧，结婚生子是人家的私事，粉丝是不是管得太宽了？不过隐瞒这么多年确实不太合适。',
    date: '2026-07-01',
    likes: 289,
  },
  {
    id: 'comment-004',
    author: '脱粉回踩',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20disappointed%20young%20Chinese%20woman%20with%20sad%20expression%2C%20holding%20crumpled%20poster%2C%20warm%20natural%20lighting%2C%20clean%20simple%20background%2C%20social%20media%20profile%20photo%20style&width=80&height=80&seq=comment-avatar-004&orientation=squarish',
    content: '五年老粉在此，连夜把家里所有周边都扔了。不是因为结婚生子，而是因为他欺骗了所有人五年！亏我到处跟人安利他！',
    date: '2026-07-01',
    likes: 892,
  },
  {
    id: 'comment-005',
    author: '内娱观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20professional%20looking%20Chinese%20male%20journalist%20with%20serious%20analytical%20expression%2C%20wearing%20blazer%2C%20warm%20natural%20lighting%2C%20clean%20simple%20background%2C%20social%20media%20profile%20photo%20style&width=80&height=80&seq=comment-avatar-005&orientation=squarish',
    content: '这绝对是今年内娱最大的瓜了，没有之一。吃瓜爆料的报道速度快、内容详实，已经成为我每天必刷的平台。',
    date: '2026-07-01',
    likes: 456,
  },
  {
    id: 'comment-006',
    author: '路人甲',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20avatar%20of%20a%20friendly%20young%20Chinese%20college%20student%20with%20relaxed%20expression%2C%20casual%20hoodie%2C%20warm%20natural%20lighting%2C%20clean%20simple%20background%2C%20social%20media%20profile%20photo%20style&width=80&height=80&seq=comment-avatar-006&orientation=squarish',
    content: '我每天上学路上都在刷吃瓜爆料，地铁上周围人都在看我的屏幕哈哈，真的太上头了，每日大赛的投票功能也超好玩！',
    date: '2026-06-30',
    likes: 178,
  },
];